import { HIDE_LOCATION_OPTIONS } from "../../global";

const locationFacilityOption = [
  { id: "1", label: "Permanent Facility" },
  { id: "2", label: "Site Facility" },
  { id: "3", label: "Mobile Facility" },
];

export const locationFacility = locationFacilityOption.filter(item => !HIDE_LOCATION_OPTIONS.includes(item.id));

export const calType = [
  { id: 1, label: "NABL" },
  { id: 2, label: "NON NABL" },
];